import { lazy } from "react";

import { SolicitudLayoutV2 } from "../layouts/SolicitudLayoutV2";
import Solicitud from "@features/Solicitud/pages/Solicitud";
import RutaProtegida from "@components/RutaProtegida.tsx";
import WhiteZone from "@components/WhiteZone";

const SolicitudV2 = lazy(() => import("../subFeatures/InfoGeneral/components/sections/SolicitudV2"));
const PerfilCrediticioV2 = lazy(() => import("../subFeatures/PerfilFinanciero/pages/PerfilCrediticioV2"));
const PerfilIdentidadV2 = lazy(() => import("../subFeatures/PerfilIdentidad/pages/PerfilIdentidadV2"));
const PerfilPLDV2 = lazy(() => import("../subFeatures/PerfilPLD/pages/PerfilPLDV2"));
const OfertaV2 = lazy(() => import("../subFeatures/Oferta/pages/OfertaV2"));
const DictamenLegalV2 = lazy(() => import("../subFeatures/DictamenLegal/pages/DictamenLegalV2"));
const ExpedienteV2 = lazy(() => import("../subFeatures/Expediente/pages/ExpedienteV2"));
const CreditoIdentidadV2 = lazy(() => import("../subFeatures/CreditoIdentidad/pages/CreditoIdentidadV2"));
const PldIntegralV2 = lazy(() => import("../subFeatures/PldIntegral/pages/PldIntegralV2"));
const VisitaOcularV2 = lazy(() => import("../subFeatures/VisitaOcular/pages/VisitaOcularV2"));
const RevisionControlV2 = lazy(() => import("../subFeatures/RevisionControl/pages/RevisionControlV2"));
const CarteraDispersionV2 = lazy(() => import("../subFeatures/CarteraDispersion/pages/CarteraDispersionV2"));
const ContractualesV2 = lazy(() => import("../subFeatures/Contractuales/pages/ContractualesV2"));
const RevisionControlPosFirmaV2 = lazy(() => import("../subFeatures/RevisionControlPosFirma/pages/RevisionControlPosFirmaV2"));
const ResumenOperacionV2 = lazy(() => import("../subFeatures/ResumenOperacion/pages/ResumenOperacionV2"));
const ContratosV2 = lazy(() => import("../subFeatures/Contratos/pages/ContratosV2"));

export const solicitudV2Routes = {
    element: <RutaProtegida />,
    children: [
        {
            Component: SolicitudLayoutV2,
            path: "/v2/solicitud",
            errorElement: <WhiteZone error />,
            children: [
                {
                    path: ":companyName/:id",
                    Component: Solicitud,
                    children: [
                        { index: true, Component: SolicitudV2 },
                        { path: "perfil_financiero", Component: PerfilCrediticioV2 },
                        { path: "perfil_persona", Component: PerfilIdentidadV2 },
                        { path: "perfil_legal", Component: PerfilPLDV2 },
                        { path: "oferta", Component: OfertaV2 },
                        { path: "dictamen_legal", Component: DictamenLegalV2 },
                        { path: "expediente", Component: ExpedienteV2 },
                        { path: "riesgo_identidad", Component: CreditoIdentidadV2 },
                        { path: "pld_integral", Component: PldIntegralV2 },
                        { path: "visita_integral", Component: VisitaOcularV2 },
                        { path: "revision_control", Component: RevisionControlV2 },
                        { path: "cartera_dispersion", Component: CarteraDispersionV2 },
                        { path: "contractuales", Component: ContractualesV2 },
                        { path: "revision_control_post-firma", Component: RevisionControlPosFirmaV2 },
                        { path: "resumen", Component: ResumenOperacionV2 },
                        { path: "contratos", Component: ContratosV2 },
                    ],
                },
            ],
        },
    ],
};
